exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.custom-page[data-v-4aa22ee8]{\r\n  padding: 25px;\n}\n.custom-page-title[data-v-4aa22ee8]{\r\n  text-align: center;\r\n  padding-bottom: 25px;\r\n  font-weight: bold !important;\r\n  font-size: 24px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4aa22ee8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/custom-page.vue
// module id = 607
// module chunks = 0